((root, factory) => {
  const helpers = factory();
  if (typeof module === 'object' && module.exports) { module.exports = helpers; return; }
  const main = document.querySelector('main.theme-template-collection');
  if (!main) return;
  const headerElement = document.querySelector('#x-header-container');
  if (headerElement) {
    const updateHeaderOffset = () => main.style.setProperty('--ev-browse-header-height', `${headerElement.getBoundingClientRect().height}px`);
    updateHeaderOffset();
    new ResizeObserver(updateHeaderOffset).observe(headerElement);
  }
  const read = () => JSON.parse(main.querySelector('#ev-collection-data')?.textContent || 'null');
  const node = (tag, className, text) => {
    const result = document.createElement(tag);
    result.className = className;
    if (text) result.textContent = text;
    return result;
  };
  const controls = (data, suffix) => {
    const box = node('div', 'ev-tag-controls');
    for (const group of Object.keys(helpers.groups)) {
      const tags = helpers.availableTags(data, group, location.href);
      if (!tags.length) continue;
      const label = node('label', 'ev-tag-field');
      const select = node('select', 'ev-tag-select');
      select.id = `ev-${group}-${suffix}`;
      label.htmlFor = select.id;
      label.append(node('span', '', data.copy[group]));
      const all = node('option', '', data.copy[group === 'metal' ? 'all_metals' : 'all_styles']);
      all.value = '';
      select.append(all);
      for (const tag of tags) {
        const option = node('option', '', helpers.label(tag, data.copy));
        option.value = tag;
        option.selected = (data.current_tags || []).includes(tag);
        select.append(option);
      }
      select.addEventListener('change', event => {
        event.stopPropagation();
        location.assign(helpers.tagUrl(location.href, data, group, select.value));
      });
      label.append(select);
      box.append(label);
    }
    return box;
  };
  const initialize = () => {
    const data = read();
    const toolbar = main.querySelector('.v2-filter-toolbar');
    if (!data || !toolbar) return;
    const unapplied = main.querySelector('[data-unapplied-filters]');
    if (unapplied) unapplied.hidden = ![...new URLSearchParams(location.search).keys()].some(key => key.startsWith('filter.'));
    data.product_types = [...new Set([...main.querySelectorAll('input[name="filter.p.product_type"]')].map(field => field.value))];
    const signature = JSON.stringify([data.current_tags, ...Object.keys(helpers.groups).map(group => helpers.availableTags(data, group, location.href))]);
    const syncControls = (container, suffix) => {
      if (!container) return;
      const previous = container.querySelector('.ev-tag-controls');
      if (previous?.dataset.signature === signature) return;
      const next = controls(data, suffix);
      next.dataset.signature = signature;
      if (previous) previous.replaceWith(next);
      else if (suffix === 'sheet') container.prepend(next);
      else container.append(next);
    };
    main.classList.add('ev-collection-browsing');
    // The native Metal Type option only covers multi-metal variants. The product
    // tag control above includes single-metal products as well.
    main.querySelectorAll('input[name="filter.v.option.metal type"]').forEach(field => {
      field.closest('.filter-advanced, .js-filter')?.classList.add('ev-variant-metal-filter');
    });
    syncControls(toolbar, 'toolbar');
    const sheet = main.querySelector('#ProductFilter .overflow-auto');
    syncControls(sheet, 'sheet');
    const sort = main.querySelector('#FormSelectFilter');
    if (sort) sort.setAttribute('aria-label', data.copy.sort);
    const header = main.querySelector('#header-filter');
    let chips = header.querySelector('.ev-active-tags');
    if (!chips) {
      chips = node('nav', 'ev-active-tags');
      chips.setAttribute('aria-label', data.copy.selected_filters);
      header.append(chips);
    }
    const chipSignature = JSON.stringify([data.current_tags, location.search]);
    if (chips.dataset.signature !== chipSignature) {
      chips.dataset.signature = chipSignature;
      chips.replaceChildren();
      for (const tag of data.current_tags || []) {
        const link = node('a', 'ev-active-tag', `${helpers.label(tag, data.copy)} ×`);
        link.href = helpers.removeTagUrl(location.href, data, tag);
        link.setAttribute('aria-label', `${data.copy.remove}: ${helpers.label(tag, data.copy)}`);
        chips.append(link);
      }
      if ((data.current_tags || []).length) {
        const clear = node('a', 'ev-clear-tags', data.copy.clear_tags);
        clear.href = helpers.urlWithTags(location.href, data.url, []);
        chips.append(clear);
      }
      chips.hidden = !chips.childElementCount;
    }
    let count = header.querySelector('.ev-browse-count');
    if (!count) {
      count = node('span', 'ev-browse-count');
      count.id = 'ProductCount_header';
      count.setAttribute('aria-live', 'polite');
      toolbar.append(count);
    }
    const countText = main.querySelector('#ProductCount')?.textContent.trim() || data.count_label;
    if (count.textContent !== countText) count.textContent = countText;
  };
  initialize();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; initialize(); });
  }).observe(main, {childList:true, subtree:true});
})(typeof window === 'undefined' ? globalThis : window, () => {
  const groups = {
    metal: ['14k Yellow Gold','10k Yellow Gold','18k Yellow Gold','22k Yellow Gold','14k White Gold','10k White Gold','14k Rose Gold','10k Rose Gold','Sterling Silver','Silver/14k Two-Tone','14k Two-tone','10k Two-tone','14k Tri-Color','10k Tri Color','14k Yellow & Rhodium','10k Yellow w/Rhodium','SS/Gold Plated','SS/Flash Plated Gold Tone','SS/Flash Plated Rose Tone'],
    style: ['Hoop Earrings','Stud Earrings','Ball & Button Earrings','Drop & Dangle Earrings','Wedding Bands','Fashion Rings','Stackable','Gemstone Rings','CZ Rings','Chain Necklaces','Bar Necklaces','Locket Necklaces','Gemstone Necklaces','Multi-Strand Necklaces','Bangle Bracelets','Cuff Bracelets','Link Bracelets','ID Bracelets','Adjustable Bracelets','Stretch Bracelets']
  };
  const handle = tag => tag.toLowerCase().replace(/[']/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const availableTags = (data, group, current) => {
    let tags = groups[group].filter(tag => data.tags.includes(tag));
    const selected = data.current_tags || [];
    if (selected.length && !selected.some(tag => groups[group].includes(tag)) && Array.isArray(data.matching_tags) && data.matching_tags.length) {
      tags = tags.filter(tag => data.matching_tags.includes(tag));
    }
    if (group !== 'style') return tags;
    const selectedTypes = data.native_filter_count === 0 ? [] : new URL(current).searchParams.getAll('filter.p.product_type').flatMap(value => value.split(','));
    const types = selectedTypes.length ? selectedTypes : (data.product_types || []);
    if (!types.length) return tags;
    return tags.filter(tag => {
      if ((data.current_tags || []).includes(tag)) return true;
      const type = tag.includes('Earrings') ? 'Earrings' : tag.includes('Bracelets') ? 'Bracelets' : tag.includes('Necklaces') ? 'Necklaces' : 'Rings';
      return types.includes(type) || (tag === 'Chain Necklaces' && types.includes('Chains'));
    });
  };
  const label = (tag, copy) => (copy['tag_' + handle(tag).replaceAll('-', '_')] || (tag === 'Silver/14k Two-Tone' ? 'Silver / 14K two-tone' : tag === 'SS/Flash Plated Rose Tone' ? 'Rose-tone sterling silver' : tag.replace(/\bk\b/g, 'K').replace(/(\d)k\b/g, '$1K'))).replaceAll('&amp;', '&');
  const urlWithTags = (current, collectionUrl, tags) => {
    const url = new URL(current);
    url.pathname = collectionUrl + (tags.length ? '/' + tags.map(handle).join('+') : '');
    for (const key of ['page','section_id','sections']) url.searchParams.delete(key);
    url.hash = 'ev-collection-results';
    return url.pathname + url.search + url.hash;
  };
  const tagUrl = (current, data, group, value) => {
    const tags = (data.current_tags || []).filter(tag => !groups[group].includes(tag));
    if (value && groups[group].includes(value) && data.tags.includes(value)) tags.push(value);
    const url = new URL(current);
    if (group === 'metal') url.searchParams.delete('filter.v.option.metal type');
    return urlWithTags(url.href, data.url, tags);
  };
  const removeTagUrl = (current, data, value) => urlWithTags(current, data.url, (data.current_tags || []).filter(tag => tag !== value));
  return {groups, handle, label, availableTags, urlWithTags, tagUrl, removeTagUrl};
});
